export enum UpdateStatus {
    PENDING = 'PENDING',
    STARTED = 'STARTED',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    COMPLETED_WITH_WARNINGS = 'COMPLETED_WITH_WARNINGS',
}
